import Link from '@/components/base/TransitionLink';
import { SHELL, INSET_X, LINE } from '@/components/base/Frame';
import SectionLabel from '@/components/base/SectionLabel';
import SectionLink from '@/components/base/SectionLink';
import { brand, navLinks } from '@/mocks/home';
import Chapter from './Chapter';

export default function ConsultSection() {
  return (
    <>
      <Chapter id="consultation">
        <div className={`${SHELL} grid grid-cols-1 lg:grid-cols-[minmax(0,7fr)_minmax(0,4fr)]`}>
          <div className={`bg-primary-50/70 py-12 md:py-20 ${INSET_X}`}>
            <SectionLabel index="05" label="Consultation" />
            <h2 className="mt-6 text-4xl font-light leading-[1.06] tracking-[-0.02em] text-foreground-950 lg:text-[52px]">
              Start with one customer workflow.
            </h2>
            <p className="mt-6 max-w-[30rem] text-base font-light leading-relaxed text-foreground-700 md:text-lg">
              Tell us where your customer operations slow down. We&rsquo;ll help identify a practical place to begin.
            </p>
          </div>
          <div className={`flex items-end border-t ${LINE} py-8 lg:border-l lg:border-t-0 lg:py-20 ${INSET_X}`}>
            <Link
              to="/contact"
              className="cursor-target flex w-full cursor-pointer items-center justify-between whitespace-nowrap bg-primary-500 px-6 py-4 text-sm text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              Discuss a Workflow
              <span>&rarr;</span>
            </Link>
          </div>
        </div>
      </Chapter>

      <footer className="pb-10 md:pb-14">
        <div className={SHELL}>
          <div className={`flex flex-col gap-6 border-y ${LINE} py-8 ${INSET_X} md:flex-row md:items-end md:justify-between`}>
            <div>
              <Link to="/" className="cursor-target cursor-pointer text-lg text-foreground-950">
                {brand.name}<span className="ml-1 font-light text-foreground-600">/</span>
              </Link>
              <p className="mt-2 text-sm text-foreground-700">{brand.descriptor}</p>
              <p className="mt-4 font-label text-[11px] text-foreground-500">&copy; 2026 {brand.name}. All rights reserved.</p>
            </div>
            <nav className="flex flex-wrap gap-x-8 gap-y-2">
              {navLinks.map((l) => (
                <SectionLink key={l.href} section={l.href} className="cursor-target cursor-pointer whitespace-nowrap text-sm text-foreground-700 hover:text-primary-500">{l.label}</SectionLink>
              ))}
              {brand.linkedin && <a href={brand.linkedin} target="_blank" rel="noopener noreferrer" className="cursor-target cursor-pointer whitespace-nowrap text-sm text-foreground-700 hover:text-primary-500">LinkedIn</a>}
            </nav>
          </div>
        </div>
      </footer>
    </>
  );
}